module.exports = __webpack_public_path__ + "img/24.cb8a07af.jpg";